import classNames from 'classnames'
import React, { forwardRef } from 'react'

import { LntInput } from '@app/components/base'

import { isEmptyString } from '@app/utils'

import styles from './styles.module.scss'

import type { InputRef } from 'antd'
import type { LntInputNumberProps } from './types'
import type { ChangeEventHandler, ForwardRefRenderFunction } from 'react'

const Component: ForwardRefRenderFunction<InputRef, LntInputNumberProps> = (props, ref) => {
  const { className: outerClassName, onChange, ...inputProps } = props

  const className = classNames(styles.lntInputNumber, outerClassName)

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event): void => {
    const value = isEmptyString(event.target.value) ? null : parseFloat(event.target.value)
    onChange?.(value)
  }

  return (
    <LntInput
      { ...inputProps }
      ref={ ref }
      type='number'
      className={ className }
      onChange={ handleChange }
    />
  )
}

export const LntInputNumber = forwardRef<InputRef, LntInputNumberProps>(Component)
